import type { Story } from '@/store/story-types'

export const SOCIAL_SHOPPING_STORY: Story = {
  id: 'social-shopping',
  name: 'StyleSnap — Social Shopping',
  narrative: 'An Instagram-style social shopping app where creators share styled looks in a photo grid, tag products, and followers can shop directly from the feed.',
  goals: ['Browse social feed', 'Discover creator stories', 'Shop tagged products', 'Manage cart and checkout'],
  lifecycle: 'building',
  pages: [
    {
      id: 'pg-home',
      title: 'StyleSnap — Shop',
      order: 0,
      status: 'draft',
      elementCount: 5,
      linkedPageId: 'home',
      description: 'Social feed with creator stories, shoppable photo grid, and curated collections',
      blockRef: { category: 'social', blockId: 'ss-shop-grid' },
    },
    {
      id: 'pg-cart',
      title: 'Cart',
      order: 1,
      status: 'draft',
      elementCount: 3,
      linkedPageId: 'cart',
      description: 'Shopping cart with items added from social feed',
      blockRef: { category: 'commerce', blockId: 'cart-view' },
    },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'Browse Social Feed',
      description: 'Visitor browses the social shopping feed',
      steps: [
        { type: 'given', text: 'the visitor is on the homepage' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'creator stories, a shoppable photo grid, and collections are visible', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'View Creator Stories',
      description: 'Visitor taps on a creator story',
      steps: [
        { type: 'given', text: 'the visitor is on the homepage' },
        { type: 'when', text: 'they tap on a creator story bubble' },
        { type: 'then', text: 'the story expands with styled looks and tagged products', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Shop from Photo Grid',
      description: 'Visitor taps a product tag on a photo',
      steps: [
        { type: 'given', text: 'the visitor is browsing the photo grid' },
        { type: 'when', text: 'they tap a product tag on a photo' },
        { type: 'then', text: 'the product details overlay with price and add-to-cart button appears', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Add to Cart from Feed',
      description: 'Visitor adds a tagged product to cart',
      steps: [
        { type: 'given', text: 'the visitor sees a product overlay' },
        { type: 'when', text: 'they tap Add to Cart' },
        { type: 'then', text: 'the product is added and the cart badge updates', linkedPageId: 'home', linkedFlowId: 'addToCart' },
      ],
    },
    {
      id: 'bdd-5',
      name: 'Review Cart and Checkout',
      description: 'Visitor reviews cart items and proceeds to purchase',
      steps: [
        { type: 'given', text: 'the visitor has items in the cart' },
        { type: 'when', text: 'they navigate to the Cart page' },
        { type: 'then', text: 'all items with quantities, prices, and a checkout button are displayed', linkedPageId: 'cart' },
        { type: 'and', text: 'they can proceed to complete the purchase', linkedFlowId: 'proceedToCheckout' },
      ],
    },
  ],
}
